export default __webpack_public_path__ + "static/media/content-4.acdfa9df.jpg";